export enum TMOptions {
  'custom' = 'New Custom template',
  'pre_made' = 'Pre-made template',
}
